import { render, staticRenderFns } from "./GenAiChatBox.vue?vue&type=template&id=3c5cf1b5&scoped=true&lang=pug"
import script from "./GenAiChatBox.js?vue&type=script&lang=js&external"
export * from "./GenAiChatBox.js?vue&type=script&lang=js&external"
import style0 from "./GenAiChatBox.vue?vue&type=style&index=0&id=3c5cf1b5&prod&scoped=true&lang=css"
import style1 from "./GenAiChatBox.vue?vue&type=style&index=1&id=3c5cf1b5&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5cf1b5",
  null
  
)

export default component.exports